// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3HmTp","footer":"ModalInfo_footer__37Bjl"};